import { useState, useEffect } from 'react';

const useOnScreen = ({ ref, name }) => {
  const [isIntersecting, setIntersecting] = useState({});
  useEffect(() => {
    const refElement = ref.current;
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(() => ({ [name]: entry.isIntersecting }));
      if (entry.isIntersecting) observer.unobserve(refElement);
    });
    if (refElement) {
      observer.observe(refElement);
    }
    return () => {
      if (refElement) observer.unobserve(refElement);
    };
  }, [ref, name]);
  return isIntersecting[name];
};
export default useOnScreen;
